import {FaRegCommentDots, FaRegFileWord} from "react-icons/fa";
import Tabs from "../../../../components/Tabs/Tabs";
import Switch from "../../../../components/Switch/DetSwitch/Switch";
import {useState} from "react";
import dummyData from "./variables/dummyData";
import VocabInfo from "./Components/VocabInfo";
import useVocab from "../../../../hooks/useVocab";
import VocabLoadingAnimation from "./Components/LoadingAnimation";
import useVocabFavorite from "../../../../hooks/useVocabFavorite";
import {LiaBatteryEmptySolid} from "react-icons/lia";
import Filter from "../../practice/component/Filter";
import PracticePageFilter from "../../practice/variables/PracticePageFilter";
import {DifficultyFilter, SortingFilter} from "./variables/FiltersData";
import {useSession} from "../../../../redux/Reducers/AuthReducer";
import Paginator from "../../../../components/Table/Paginator";

const TABS = [
    {
        key: "high-frequency",
        title: "High Frequency",
        icon: FaRegCommentDots
    }, {
        key: "read-and-select",
        title: "Read and Select",
        icon: FaRegCommentDots
    },
    {
        key: "read-and-complete",
        title: "Read and Complete",
        icon: FaRegCommentDots
    }, {
        key: "completed-the-sentence",
        title: "Complete the Sentence",
        icon: FaRegCommentDots
    }

]


export default function VocabularyIndex({className, ...props}) {
    const selectedTab = "high-frequency"
    const [mask, setMask] = useState({
        word: true,
        definition: true,
        example: false,
        synonym: false,
    });
    const [vocab, filter, isLoading, vocabActions] = useVocab(selectedTab)
    const [favorite, isFavLoading, favoriteActions] = useVocabFavorite()
    const {session, authActions} = useSession();
    let tabs = !authActions.hasActiveSubscription() ? TABS : [...TABS, {
        key: "my-vocabulary",
        title: "My Vocabulary",
        icon: FaRegCommentDots
    }]


    return (
        <div className={`flex flex-col p-8 mb-8  lg:p-0 justify-center items-center lg:pt-10 ${className}`}>
            <div
                className={"w-full relative lg:w-[70%] gap-8 flex flex-col  2xl:w-[65%] bg-white shadow-md  rounded-md"}>
                <div className={" w-full rounded-lg p-4 lg:px-8   top-0 bg-white  flex flex-col"}>
                    <div className={"max-w-[70vw] "}>
                        <Tabs
                            className={"lg:justify-between overflow-x-hidden "}
                            defaultSelected={selectedTab}
                            onChange={(value) => {
                                vocabActions.setCategory(value)
                            }}
                            tabs={tabs}
                        />
                    </div>
                    <div>
                        <div className={"flex flex-row gap-8 my-8"}>
                            <Filter {...SortingFilter}
                                    defaultValue={filter?.sortBy}
                                    onChange={(value) => {
                                        vocabActions.UpdateFilter({sortBy: value})

                                    }}/>
                            <Filter defaultValue={filter?.difficulty} {...DifficultyFilter} onChange={(value) => {

                                vocabActions.UpdateFilter({difficulty: value})
                            }}/>
                        </div>
                        <div className={" flex flex-row gap-4"}>
                            <Switch
                                defaultChecked={mask.word}
                                onChange={(e) => setMask({...mask, word: e?.target?.checked})}
                                label={"Word"}/>
                            <Switch
                                defaultChecked={mask.definition}
                                onChange={(e) => setMask({...mask, definition: e?.target?.checked})}
                                label={"Definition"}/>
                            <Switch
                                defaultChecked={mask.example}
                                onChange={(e) => setMask({...mask, example: e?.target?.checked})}
                                label={"Example"}/>
                            <Switch

                                defaultChecked={mask.synonyms}
                                onChange={(e) => setMask({...mask, synonyms: e?.target?.checked})}
                                label={"Synonym"}/>
                            <div className={"flex-1 flex justify-end"}>
                                <p className={"ml-auto font-semibold text-sm"}>
                                    Total: <span className={"text-secondary-900"}>{vocab?.count} </span>
                                </p>


                            </div>
                        </div>
                    </div>
                </div>
                <div className={"p-4 lg:px-8   "}>
                    {isLoading && <VocabLoadingAnimation num={5}/>}
                    {
                        !isLoading && vocab?.count === 0 && <div className={"flex flex-col mt-12 gap-2 items-center"}>
                            <FaRegFileWord className={"text-4xl"}/>

                            <p className={"font-bold text-xl text-center"}>
                                Nothing to see here
                            </p>

                        </div>
                    }
                    {
                        !isLoading && vocab?.results?.map((item, index) => {
                            return (
                                <VocabInfo isFavorited={favoriteActions.isFavorite(item?.id)}
                                           toggleFav={(data) => {
                                               if (authActions.hasActiveSubscription())
                                                   favoriteActions.addRemoveFavorite(data)
                                               else {
                                                   authActions.showSubscriptionModal()
                                               }
                                           }} key={index} data={item}
                                           mask={mask}/>
                            )
                        })
                    }

                </div>

                <div className={"py-4 w-full flex justify-center items-center"}>
                    {!isLoading && vocab?.count > 0 && <Paginator
                        currentPage={vocab?.currentPage}
                        totalPages={vocab?.totalPages}
                        hasGoToBox
                        onNext={vocabActions.loadNextPage}
                        onPrev={vocabActions.loadPrevPage}
                        onPageNumberClick={vocabActions.loadSpecificPage}


                    />}
                </div>


            </div>
        </div>

    )
}